import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { StripeRegistrationFooter } from './components/StripeRegistrationFooter';
import { StripeRegistrationForm } from './components/StripeRegistrationForm';
import type { StripeRegisterFormValues } from './StripeRegisterFormSchema';
import { StripeRegisterFormSchema } from './StripeRegisterFormSchema';

export const RegisterToStripeComponents: FormDrawerProps<ZodSchema<StripeRegisterFormValues>> = {
  zodSchema: StripeRegisterFormSchema,
  ContentComponent: StripeRegistrationForm,
  Footer: StripeRegistrationFooter,
};
